import "../styleSheets/hero.css";
import "../styleSheets/buttons.css";
import { useTranslation } from "react-i18next";
import { ReactComponent as Eterniqicon } from "../images/eterniq-icon.svg";
import { useNavigate } from "react-router-dom";
import { trackEvent } from "../utilities/analytics";

function Hero() {
  const { t } = useTranslation("common");
  const navigate = useNavigate();

  const handleCTAButton = () => {
    trackEvent("pricing_cta_clicked");
    navigate("/Plans", { state: null });
  };

  return (
    <section className="section-hero" aria-labelledby="home-hero-title">
      <div className="sub-container-hero">
        <div className="sub-container-left">
          <div className="content-hero">
            <Eterniqicon role="img" aria-label={t("header.logoAlt")} />
            <h1 id="home-hero-title" className="content-hero-title">
              {t("pageBody.hero.title")}
            </h1>
            <div className="divider" />
            <div className="content-hero-text">{t("pageBody.hero.text")}</div>
          </div>
          <div className="container-button-cta">
            <button
              type="button"
              className="btn btn--cta btn--size-cta"
              onClick={handleCTAButton}
            >
              {t("pageBody.hero.buttonText")}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
